import { gql } from '@apollo/client';

export const GET_ALL_OBJECTIONS = gql`
	query GetAllObjections(
		$page: Int!
		$limit: Int!
		$sort: [SortInput]
		$filters: ObjectionFilterInput
	) {
		objections(
			pagination: { page: $page, limit: $limit }
			sort: $sort
			filters: $filters
		) {
			items {
				id
				company {
					id
					gorkoId
					name
					isGorkoCommission
					isGorkoAbonent
					isGorkoHidden
					isGorkoDeleted
				}
				createdBy {
					id
					name
					gorkoId
				}
				type {
					id
					name
					createdAt
					updatedAt
				}
				solved
				solvedAt
				comment
				createdAt
			}
			pagination {
				currentPage
				totalPages
				totalCount
			}
		}
	}
`;
